const initialState = {
    ansa_token: JSON.parse(localStorage.getItem('ansa_token')) || null,
};

const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_TOKEN':
            localStorage.setItem('ansa_token', JSON.stringify(action.payload));
            return {
                ...state,
                ansa_token: action.payload,
            };
        default:
            return state;
    }
};

export default tokenReducer;